// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"60":"ff55d5fe","428":"f05d3c8e","819":"8dfba0c4"}[chunkId] + ".chunk.js";
};